'use client'

import { LinkButton } from 'components/Contentful'
import Cookies from 'js-cookie'
import { useMemo } from 'react'
import { getProductAndAddDefaultUtmsToLink } from 'utils/queryManipulation'
import { preserveQueryParams } from 'utils/shared'

const BasicSectionCta = ({ cta }) => {
  const visitId = Cookies.get('eh_visit_id')

  const memoHref = useMemo(
    () => getProductAndAddDefaultUtmsToLink(preserveQueryParams(cta.linkHref, {}, visitId)),
    [visitId, cta.linkHref]
  )

  if (!cta) return null

  return (
    <div className="flex flex-col justify-center items-center w-full pt-4 lg:pt-6">
      <LinkButton
        className="min-w-[105px] h-[47px]"
        content={{ ...cta, linkHref: memoHref }}
        typographicOptions={{
          fontWeight: 'bold',
          'data-testid': `basic-hero-cta-button-text`,
          className: 'min-w-[105px] text-center',
        }}
        color={'primary'}
        data-testid={`basic-hero-cta-button`}
        track={{
          ...{
            list_name: 'Basic Hero CTA',
            click_id: cta.linkText?.json.content?.[0]?.content[0]?.value,
            click_text: cta.linkText?.json.content[0]?.content[0]?.value,
            click_url: memoHref,
            click_position: '0',
            track_event: 'internal_campaign_click',
            event_action: 'button_click',
            event_type: 'button_click',
          },
          ...cta.event,
        }}
      />
    </div>
  )
}

export { BasicSectionCta }
export default BasicSectionCta
